export const banimodeUserProd = JSON.parse(
  localStorage.getItem("banimodeUserProd")!
);
export const baseURLGame = "/tara";
export const V1API = "/v1";
export const V2API = "/v2";
export const V3API = "/v3";
export const V4API = "/v4";
export const LOCAL_PERFIX = "gardone1402_";
export const REQUEST = "/auth/request";
export const AUTH = "/auth";
export const USER = "/user";
export const CLIENT_INFO = "/app/client_info";
export const TARA_WALLET = "/user/inquiry";
